var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-family"},[_c('h1',[_vm._v("Add a family")]),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.saveFamily()}}},[_c('fieldset',[_c('text-input',{attrs:{"label":'Family name',"required":true},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}}),_c('text-area',{attrs:{"label":'Embed code',"markdown":false},model:{value:(_vm.embed),callback:function ($$v) {_vm.embed=$$v},expression:"embed"}})],1),_vm._l((_vm.fonts),function(font,key){return _c('fieldset',{key:key},[_c('text-input',{attrs:{"label":'Font name',"required":true},model:{value:(_vm.fonts[key].title),callback:function ($$v) {_vm.$set(_vm.fonts[key], "title", $$v)},expression:"fonts[key].title"}}),_c('text-input',{attrs:{"label":'Font short name',"required":true},model:{value:(_vm.fonts[key].name),callback:function ($$v) {_vm.$set(_vm.fonts[key], "name", $$v)},expression:"fonts[key].name"}}),_c('text-input',{attrs:{"label":'File name'},model:{value:(_vm.fonts[key].file),callback:function ($$v) {_vm.$set(_vm.fonts[key], "file", $$v)},expression:"fonts[key].file"}}),_c('select-input',{attrs:{"label":'Weight',"options":[
          {
            value: '',
            label: 'Select one'
          },
          {
            value: '100',
            label: '100'
          },
          {
            value: '200',
            label: '200'
          },
          {
            value: '300',
            label: '300'
          },
          {
            value: '400',
            label: '400'
          },
          {
            value: '500',
            label: '500'
          },
          {
            value: '600',
            label: '600'
          },
          {
            value: '700',
            label: '700'
          },
          {
            value: '800',
            label: '800'
          },
          {
            value: '900',
            label: '900'
          }
        ]},model:{value:(_vm.fonts[key].weight),callback:function ($$v) {_vm.$set(_vm.fonts[key], "weight", $$v)},expression:"fonts[key].weight"}}),_c('lw-switch',{attrs:{"label":'Italic'},model:{value:(_vm.fonts[key].italic),callback:function ($$v) {_vm.$set(_vm.fonts[key], "italic", $$v)},expression:"fonts[key].italic"}}),_c('lw-switch',{attrs:{"label":'Headline sizes'},model:{value:(_vm.fonts[key].headline),callback:function ($$v) {_vm.$set(_vm.fonts[key], "headline", $$v)},expression:"fonts[key].headline"}}),_c('lw-switch',{attrs:{"label":'Text sizes'},model:{value:(_vm.fonts[key].text),callback:function ($$v) {_vm.$set(_vm.fonts[key], "text", $$v)},expression:"fonts[key].text"}})],1)}),_c('button',{on:{"click":function($event){$event.preventDefault();_vm.addFont()}}},[_vm._v("+ Add font")]),_c('button',{attrs:{"type":"submit"}},[_vm._v("Save family")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }